import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { FilterYear } from '../../components/Reports/FilterYear';
import { ResponseError } from '../../../common/pokCore/autogenerated/pokApiClient';
import { Waiting } from '../../../common/components/Waiting/Waiting';
import { useAuth } from '../../../common/hooks/useAuth';
import { PermissionsEnum } from '../../../common/pokCore/authorization/permissions';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { FilterYearReportData } from '../../components/Reports/types/FilterYearTypes';

export const ReportProjectByMonthDataRawView: React.FC = () => {
  const pok = usePokCore();

  const notifications = useNotifications();
  const [waiting, setWaiting] = useState<boolean>(false);
  const [alert, setAlert] = useState<string>('');

  const auth = useAuth();
  const [authorized, setAuthorized] = useState<boolean>();
  const { t, tk } = useTranslation('reportLng');

  useEffect(() => {
    setAuthorized(auth.check(PermissionsEnum.FinanceAdministration));
  }, [pok, auth]);

  const onSearch = async (filter: FilterYearReportData) => {
    setAlert(t(tk.menu.dataDownload));
    setWaiting(true);

    const currentDate = new Date().toISOString().split('T')[0];
    try {
      await pok.reports.reportProjectByMonthRawData(
        `${t(tk.finance.reportToBudget)}_${currentDate}.xlsx`,
        filter,
      );
      setWaiting(false);
    } catch (error) {
      notifications.caughtError(error as ResponseError);
      setWaiting(false);
    }
  };

  return (
    <>
      <FilterYear
        onSearch={onSearch}
        reportName={t(tk.prLang.reportToBudgetByMonth)}
        withYear={true}
        withoutCompany={authorized ? false : true}
        isLoading={waiting}
      />
      {waiting && (
        <>
          <Alert variant="warning">{alert}</Alert>
          <Waiting />
        </>
      )}
    </>
  );
};
